import { api_GetCustomerDeliveryZones } from "../../connection/api/api-profile";
import { GET_DIVISION_DETAILS } from "../../database/get-stored-data";
import DropDown from "../dropdown/drop-down";
import React from "react";
import "../../styles/css/pg-home-drawer-zone-table.css";
import { Colors } from "../../util/colors";

export default class RENDER_DRAWER_ZONE extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      Zones: [],
      Divisions: [],
      searchTerm: "",
      filteredZones: [],
      changeStart: false,
    };
    this.dropdownRefs = {};
  }

  async componentDidMount() {
    await this.LoadZones();
    let data = await GET_DIVISION_DETAILS();
    if (data) {
      data.sort((a, b) =>
        a.DevisionDescription.localeCompare(b.DevisionDescription)
      );
      this.setState({ Divisions: data });
    } else {
      this.setState({ Divisions: [] });
    }
  }

  async LoadZones() {
    let data = await api_GetCustomerDeliveryZones();
    if (data !== "") {
      let objData = JSON.parse(data);

      objData.forEach((zone) => {
        zone.Description =
          zone.Description.charAt(0).toUpperCase() +
          zone.Description.slice(1).toLowerCase();
      });

      objData.sort((a, b) => a.Description.localeCompare(b.Description));

      this.setState({ Zones: objData, filteredZones: objData });
    } else {
      this.setState({ Zones: [] });
    }
  }

  handleSearchTermChange = (event) => {
    const searchTerm = event.target.value;
    const { Zones, Divisions } = this.state;
    const hasSearchTerm = searchTerm.trim() !== "";

    const filteredZones = Zones.filter((zone) =>
      zone.Description.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const matchingDivisionIds = new Set(
      filteredZones.map((zone) => zone.DevisionID)
    );

    const filteredDivisions = Divisions.filter((division) =>
      matchingDivisionIds.has(division.DevisionID)
    );

    this.setState(
      {
        filteredZones: hasSearchTerm ? filteredZones : Zones,
        searchTerm,
        filteredDivisions,
        changeStart: hasSearchTerm,
      },
      () => {
        this.updateDropdownStates(matchingDivisionIds, hasSearchTerm);
      }
    );
  };

  clearSearchTerm = () => {
    const { Zones } = this.state;
    this.setState(
      {
        searchTerm: "",
        filteredZones: Zones,
        filteredDivisions: [],
        changeStart: false,
      },
      () => {
        this.updateDropdownStates(new Set(), false);
      }
    );
  };

  updateDropdownStates = (matchingDivisionIds, hasSearchTerm) => {
    Object.values(this.dropdownRefs).forEach((dropdownRef) => {
      if (!dropdownRef || dropdownRef.props.isOneDivv) {
        return;
      }
      const shouldOpen =
        hasSearchTerm && matchingDivisionIds.has(dropdownRef.props.DivisionID);
      dropdownRef.setOpen(shouldOpen);
    });
  };

  render() {
    const { Divisions, searchTerm, filteredZones } = this.state;
    const isOneDiv = Divisions.length > 1;

    return (
      <div>
        {isOneDiv ? (
          <div className="Search">
            <div className="SearchInputWrapper">
              <input
                ref={(input) => (this.searchInput = input)}
                className="Searchbar"
                type="text"
                placeholder="Search Zones..."
                value={searchTerm}
                onChange={this.handleSearchTermChange}
                style={{border: "1px solid " + Colors.DarkGreyScale,}}
              />
              {searchTerm ? (
                <button
                  type="button"
                  className="SearchClear"
                  onClick={this.clearSearchTerm}
                  aria-label="Clear search"
                >
                  <i className="bi bi-x-circle-fill" />
                </button>
              ) : null}
            </div>
          </div>
        ) : null}

        {Divisions.map((rs) => (
          <DropDown
            ref={(dropdown) => {
              if (dropdown) {
                this.dropdownRefs[rs.DevisionID] = dropdown;
              }
            }}
            key={rs.DevisionID}
            title={rs.DevisionDescription}
            options={filteredZones}
            DivisionID={rs.DevisionID}
            SelectZone={(zone) => this.props.SelectZone(zone)}
            isOneDivv={!isOneDiv}
          />
        ))}
      </div>
    );
  }
}
